import React from 'react';
import { cn } from '../../../utils/cn';
import StatusBadge from './StatusBadge';

const actionClass = 'rounded-full border border-gray-300 px-3 py-1 text-sm text-gray-700 hover:border-orange-400 disabled:text-gray-300';

const ThreadActions = ({ status, canWrite, closed, isMine, updatingStatus, onShowCard, onChangeStatus }) => {
  const actions = [
    { key: 'user', label: 'О пользователе', onClick: onShowCard, show: true },
    {
      key: 'take',
      label: 'Взять в работу',
      onClick: () => onChangeStatus('in_progress'),
      show: canWrite && !closed && !isMine,
      disabled: updatingStatus,
    },
    {
      key: 'close',
      label: 'Закрыть',
      onClick: () => onChangeStatus('closed'),
      show: canWrite && !closed,
      disabled: updatingStatus,
    },
    {
      key: 'reopen',
      label: 'Переоткрыть',
      onClick: () => onChangeStatus('in_progress'),
      show: canWrite && closed,
      disabled: updatingStatus,
    },
  ].filter((action) => action.show);

  return (
    <div className="flex flex-wrap items-center gap-2">
      <StatusBadge status={status} className="px-3 py-1 text-sm" />
      {actions.map((action) => (
        <button
          key={action.key}
          type="button"
          disabled={action.disabled}
          onClick={action.onClick}
          className={cn(actionClass, action.className)}>
          {action.label}
        </button>
      ))}
    </div>
  );
};

export default ThreadActions;
